var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Check1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.4189 20.9181C16.0565 21.1892 15.4198 21.2636 15.0016 21.0885L0.417336 13.3092C0.000643356 13.1342 -0.126379 13.2844 0.138508 13.6454L15.2866 34.4304C15.5499 34.7913 15.9759 34.7867 16.2315 34.4242L37.8515 3.63855C38.1086 3.27298 38.0234 3.19243 37.661 3.46351L16.4189 20.9197V20.9181Z",
    fill: "#4CAF50"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheck);
export default __webpack_public_path__ + "static/media/success-check.4e332fc6fcc8619943fd98a64f4f064c.svg";
export { ForwardRef as ReactComponent };